// extracted by mini-css-extract-plugin
export default {"bet":"aDnyY","betLabel":"F0l9V","increased":"K62L4","increase":"OF38Q","decreased":"XRiBU","decrease":"CqHGP"};